import _ from 'lodash';

import { LoadingIndicator } from 'components/loading';
import OnBoarding from 'customerView/onBoarding/onboardingStepper';
import * as queries from 'hooks/queries';
import useFeatureFlags from 'hooks/featureFlags';

export const OnboardingStatusVerification = ({ children, ...rest }) => {
  const query = queries.useQueryIsOnboarded();
  const featureFlags = useFeatureFlags();

  const render = _.isFunction(children) ? children : (({ isOnboarded }) => (
    !isOnboarded || featureFlags.forceOnboarding ? (
      <div className="main-content">
        <div className="scrollable-main-content">
          <OnBoarding />
        </div>
      </div>
    ) : children
  ));

  return (
    <LoadingIndicator isLoading={query?.isLoading} centered message="Verifying onboarding status...">
      {render({ isOnboarded: query?.data?.isOnboarded, ...rest })}
    </LoadingIndicator>
  );
};
